import { Component, OnInit, ElementRef, Injector, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

/**
 * Component wrapper for OrgChooserController
 */
@Component({
  selector: 'org-chooser',
  template: '<org-chooser-directive></org-chooser-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrgChooserComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // No route params needed for org-chooser component
  }
}

/**
 * Directive for downgrading OrgChooserComponent
 */
@Component({
  selector: 'org-chooser-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OrgChooserDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('orgChooser', elementRef, injector);
  }
}
